import QuickAccessFamilyContainer from './QuickAccessFamilyContainer';

export default QuickAccessFamilyContainer;
